import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

export interface DialogProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
}

const DialogComponent = ({ isOpen, onClose, title, children }: DialogProps) => {
    if (!isOpen) {
        return null;
    }

    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="md">
            <DialogTitle sx={{ m: 0, p: 2, pr: 5 }} className="bg-blue-100">
                {title}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>{children}</DialogContent>
        </Dialog>
    );
};

export default DialogComponent;